import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, makeStateKey, PLATFORM_ID, StateKey, TransferState} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ApiHelper} from '../../../services/api.helper';
import {WPUser} from '../../../types/WPUser';
import {AppConfigService} from '../../../services/app-config.service';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {TransferStateKeyEnum} from '../../../enums/TransferStateKeyEnum';

@Injectable()
export class StaticAuthorService {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private appConfigService: AppConfigService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  public GetAuthorBySlug(slug: string): Observable<WPUser> {
    const apiUrl: string = this.appConfigService.appConfig.amazonS3WpUrl;
    const endpoint = `${apiUrl}wp/users/user-${slug}.json`;

    const stateKey: StateKey<WPUser> = makeStateKey(`${TransferStateKeyEnum.AUTHOR_DATA}-${slug}`);

    if (isPlatformBrowser(this.platformId)) {
      const cachedData = this.transferState.get(stateKey, null);
      if (cachedData) {
        return new Observable<WPUser>((observer) => {
          observer.next(cachedData);
          observer.complete();
        });
      }
    }

    return this.http.get<WPUser>(endpoint).pipe(
      map((data) => {
        if (isPlatformServer(this.platformId)) {
          this.transferState.set(stateKey, data);
        }
        return data;
      }),
      catchError((error) => this.apiHelper.handleError(error)),
    );
  }
}
